import {
  Box,
  CircularProgress,
  Paper,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";

import { useHttpClient } from "@/providers/HttpClient";
import { LoggerService } from "@/shared/services";

/**
 * Displays the formatted AppConfig from the /v1/info/config endpoint
 */
export function Config() {
  const theme = useTheme();
  const { httpClient } = useHttpClient();
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const [configData, setConfigData] = React.useState<unknown>(null);
  const [error, setError] = React.useState<string | null>(null);

  React.useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const url = httpClient.constructUrl("v1/admin/config");
        const response = await httpClient.get(url);
        const data = await response.json();
        setConfigData(data);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData().catch((err) => {
      LoggerService.error("Failed to fetch config", err);
      setError("Failed to fetch config");
    });
  }, [httpClient]);

  return (
    <Paper
      variant="outlined"
      sx={{
        padding: theme.spacing(2),
        backgroundColor:
          theme.palette.code?.main || theme.palette.background.paper,
      }}
    >
      {isLoading && (
        <Box sx={{ display: "flex", justifyContent: "center", padding: 2 }}>
          <CircularProgress size="1.5rem" />
        </Box>
      )}
      {!isLoading && error && <Typography color="error">{error}</Typography>}
      {!isLoading && !error && (
        <Typography
          variant="body2"
          component={"span"}
          sx={{
            fontSize: "0.75rem",
            wordBreak: "break-all",
          }}
        >
          <pre
            style={{
              whiteSpace: "pre-wrap",
              margin: 0,
              overflowX: "auto",
            }}
          >
            {JSON.stringify(configData, null, 2)}
          </pre>
        </Typography>
      )}
    </Paper>
  );
}
